module.exports = __webpack_public_path__ + "img/Nature_Biomedical_Engineering_Cover_Article.87afb0d0.png";